import { useState } from "react";

const WA = "https://wa.me/917995495312?text=Hi%20Aria%20—%20tell%20me%20about%20your%20AI%20solutions";

const SOLUTIONS = [
  {
    key: "sales",
    icon: "📈",
    title: "Sales Automation",
    short: "Close more, follow up forever.",
    desc: "AI lead qualification, WhatsApp sales agents, CRM automation, proposal follow-ups, and automated customer nurturing.",
    features: [
      "AI lead qualification & scoring",
      "WhatsApp / Web sales agents",
      "CRM data hygiene + auto-enrichment",
      "Proposal & quote follow-up sequences",
      "Lifecycle nurturing across channels",
    ],
  },
  {
    key: "support",
    icon: "🎧",
    title: "Customer Support Automation",
    short: "Never sleep. Never lose a customer.",
    desc: "24/7 AI assistants, ticket handling, FAQs, complaint routing, customer self-service, and multi-channel support.",
    features: [
      "24/7 AI assistant on WhatsApp, web, email",
      "Ticket triage + intelligent routing",
      "Self-service knowledge base",
      "Complaint escalation workflows",
      "Multi-channel unified inbox",
    ],
  },
  {
    key: "operations",
    icon: "⚙️",
    title: "Operations Automation",
    short: "Backend that runs itself.",
    desc: "ERP automation, SAP automation, workflow automation, approval automation, backend process automation, and task orchestration.",
    features: [
      "SAP / Tally / ERP integrations",
      "Approval workflows (purchase, expense, leave)",
      "Backend process orchestration",
      "Cross-system data sync",
      "RPA bots (UiPath enterprise-grade)",
    ],
  },
  {
    key: "idp",
    icon: "📄",
    title: "Intelligent Document Processing",
    short: "PDFs become data, automatically.",
    desc: "Automated extraction from invoices, purchase orders, forms, PDFs, emails, and business documents using OCR, NLP, and AI.",
    features: [
      "Invoice / PO / GRN extraction",
      "Forms, contracts, KYC documents",
      "Email + attachment parsing",
      "Validation against ERP / business rules",
      "Straight-through processing",
    ],
  },
  {
    key: "intelligence",
    icon: "🧠",
    title: "Executive Intelligence",
    short: "Decisions, not dashboards.",
    desc: "AI business insights, predictive analytics, decision intelligence, KPI dashboards, and management reporting automation.",
    features: [
      "AI-generated business insights",
      "Predictive analytics & forecasting",
      "Decision-intelligence engines",
      "Live KPI dashboards",
      "Automated management reports",
    ],
  },
  {
    key: "workforce",
    icon: "🤖",
    title: "AI Workforce",
    short: "Hire AI employees with roles.",
    desc: "Deploy role-based AI employees — AI Sales Rep, AI Customer Service Executive, AI Operations Coordinator, AI HR Assistant, AI Finance Assistant.",
    features: [
      "Role-based AI employees",
      "Multi-agent collaboration",
      "Goal-driven autonomous task execution",
      "Plug into your existing tools",
      "Continuous learning & supervision",
    ],
  },
];

const SolutionCard = ({ s }) => (
  <article className="svc-card" data-testid={`solution-card-${s.key}`}>
    <span className="svc-icon-watermark" aria-hidden>{s.icon}</span>
    <div className="svc-card-top">
      <span className="svc-icon-pill">{s.icon}</span>
      <span className="svc-tag">{s.short}</span>
    </div>
    <div className="svc-card-body">
      <h3 className="svc-title">{s.title}</h3>
      <p className="svc-desc">{s.desc}</p>
      <ul className="svc-features">
        {s.features.map((f, i) => <li key={i}>{f}</li>)}
      </ul>
    </div>
    <div className="svc-card-foot">
      <a href={WA} target="_blank" rel="noreferrer" className="svc-learn">
        Talk to Aria →
      </a>
    </div>
  </article>
);

const Services = () => {
  const [paused, setPaused] = useState(false);
  const loop = [...SOLUTIONS, ...SOLUTIONS, ...SOLUTIONS];

  return (
    <section id="solutions" className="section bg-gold-soft" data-bg="cream" data-testid="solutions-section">
      <div className="section-inner">
        <div className="reveal">
          <span className="eyebrow">What we deliver</span>
          <h2 className="section-h2">
            AI & Automation<br />
            <span className="serif">Solutions</span>.
          </h2>
          <p className="section-sub">
            Six solution stacks that combine Agentic AI, UiPath, generative AI,
            and process automation — engineered for mid-market businesses.
          </p>
        </div>
      </div>

      <div
        className={`svc-scroll ${paused ? "paused" : ""}`}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        data-testid="svc-scroll"
      >
        <div className="svc-track">
          {loop.map((s, i) => (
            <SolutionCard key={`${s.key}-${i}`} s={s} />
          ))}
        </div>
      </div>

      <div className="section-inner svc-bottom reveal">
        <div className="svc-bottom-inner">
          <p className="svc-bottom-title">
            Don't see what you need?
          </p>
          <p className="svc-bottom-sub">
            We design custom AI + automation solutions for any business problem.
          </p>
          <a href={WA} target="_blank" rel="noreferrer" className="btn btn-gold" data-testid="svc-custom-cta">
            Book a free consultation →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
